import {
  Component,
  signal,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Button } from "../utils/button/button";
import { Icon } from "../utils/icon/icon";
import { TranslocoModule } from "@jsverse/transloco";
import { ClickOutsideDirective } from "../../directives/click-outside-directive";

@Component({
  selector: "app-language-filter",
  imports: [Button, Icon, ClickOutsideDirective, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./language-filter.html",
})
export class LanguageFilter {
  availableLanguages = input.required<string[]>();
  languagesSelected = signal<string[]>([]);
  isLanguageDropdownOpen = signal<boolean>(false);
  textToDisplayIfAnySelected = input.required<string>();

  updateResults = output<string[]>();

  toggleLanguageDropdown(): void {
    this.isLanguageDropdownOpen.set(!this.isLanguageDropdownOpen());
  }

  addLanguage(language: string): void {
    if (!this.languagesSelected().includes(language)) {
      this.languagesSelected.set([...this.languagesSelected(), language]);
      this.updateResults.emit(this.languagesSelected());
    }
  }

  removeLanguage(language: string): void {
    const updatedLanguages = this.languagesSelected().filter(
      (lang) => lang !== language
    );
    this.languagesSelected.set(updatedLanguages);
    this.updateResults.emit(this.languagesSelected());
  }

  handleLanguage(language: string): void {
    if (this.languagesSelected().includes(language)) {
      this.removeLanguage(language);
    } else {
      this.addLanguage(language);
    }
  }
}
